export default __webpack_public_path__ + "static/media/wishlists.95196233.svg";